import CalculatorLayout from '../layouts/CalculatorLayout';
import DashboardPage from '../pages/CalculatorAuth/DashboardPage';

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      layout: CalculatorLayout
    },
    component: DashboardPage
  }
];
